import { K8sTargetType } from '@/config/views/monitoring/log/utils/types';
import { type CustomColumn } from '@/common/utils';
import { escape, isNil, startCase } from 'lodash-es';
import { PathInfo } from '@/api-client/log/model';
import { isCancelError, isIgnoreRequestError } from '@/common/utils/error.utils';
import { K8S_TARGET_TYPE } from './define';

export const isK8sTargetType = (type: string): type is K8sTargetType =>
  K8S_TARGET_TYPE.includes(type as K8sTargetType);

export const formatter = (value: string | number | object | undefined) => {
  if (typeof value === 'object' && !isNil(value)) {
    return JSON.stringify(value);
  }
  return value;
};

// Note ES Data 가 정형화 되어 있지 않음.
export const generateFormatter = (columns: CustomColumn[]) => {
  return columns
    .filter((item) => !item.field.toLowerCase().includes('time'))
    .reduce(
      (acc, column) => {
        acc[column.field] = formatter;
        return acc;
      },
      {} as Record<
        string,
        (value: string | number | object | undefined) => string | number | undefined
      >,
    );
};

export const convertTextFromParseInfos = (parseInfos: Record<string, string>[]) => {
  return parseInfos
    .map((obj) =>
      Object.entries(obj)
        .map(([key, value]) => `[${key}] ${value}`)
        .join(' '),
    )
    .join(' ');
};

type ParserInfos = PathInfo['parserInfos'];
export const filterParserInfos = (parserInfos: ParserInfos) => {
  return Object.values(parserInfos ?? {})
    .map((v) => {
      return Object.entries(v).reduce(
        (acc, [key, value]) => {
          if (value) {
            acc[key] = value;
          }
          return acc;
        },
        {} as Record<string, string>,
      );
    })
    .filter((v) => Object.keys(v).length > 0);
};

export const checkRealError = (error: Error | null) => {
  const isIgnore = isIgnoreRequestError(error);
  const isCancel = isCancelError(error);
  return error && !isIgnore && !isCancel;
};

export const generatorLoggingTooltipHtml = (
  item: {
    targetType: string;
    name: string;
    value: number;
    ratio: number;
    color: string;
  },
  prefixClass: string = '',
): string => {
  const { targetType, name, value, ratio, color } = item;
  return `
  <div class="${prefixClass} logging-trend-tree-map-tooltip" style="border-color: ${color}">
    <div class="logging-trend-tree-map-tooltip__header header-title">
      <span class="header-title__icon ${targetType}"></span>
      <span class="header-title__text">${escape(name)}</span>
    </div>
    <div class="logging-trend-tree-map-tooltip__content">
      <div class="content-item">
        <span class="target-type">
          <span class="target-type__symbol" style="background-color: ${color}"></span>
          <span>Target Type</span>
        </span>
        <span>${startCase(targetType)}</span>
      </div>
      <div class="content-item">
        <span>Count</span>
        <span>${value.toLocaleString()}</span>
      </div>
      <div class="content-item">
        <span>Ratio</span>
        <span class="ratio-value">
          <span class="ratio-value__text">${ratio.toLocaleString()}</span>
          <span class="ratio-value__unit">%</span>
          <span class="ratio-value__ratio">
           <span class=ratio-value__ratio-value style="width: ${ratio}%"></span>
          </span>
        </span>
      </div>
    </div>
  </div>
`;
};
